import { CommentResponse } from '@spe-content-store/interfaces';
import { NuggetComment } from '@shared/models/nugget-comment.model';

export const toNuggetComment = (response: CommentResponse): NuggetComment => ({
    id: response.id,
    text: response.text,
    date: response.created,
    authorEmail: response.createdBy
});

export const formatCommentDate = (value: string): string => {
    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) {
        return value;
    }
    return parsed.toLocaleString('de-DE', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    });
};
